module.exports = __webpack_public_path__ + "img/dls.f1932347.png";